<template>
  <v-menu top z-index="1000">
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <div class="col-area-inner"
               :style="bgi()"
              v-bind="attrs"
              v-on="{ ...tooltip, ...menu }"
          ></div>
        </template>
        <span>Choose track color.</span>
      </v-tooltip>
    </template>
    <table style="background-color: #eeeeee">
      <tr v-for="(item, index) in htmlColors"
          :key="index">
        <td>
          <div class="col-area-inner" :style="bg(item)" @click="select(index)"/>
        </td>
      </tr>
    </table>
   </v-menu>
</template>

<script>
export default {
  name: "ColorPicker",
  props: ['value'],
  data() {
    return {
      colors: [
        'Red',
        'Green',
        'Yellow',
        'Blue',
        'Magenta',
        'Cyan',
        'DarkRed',
        'DarkGreen',
        'Gold',
        'DarkBlue',
        'DarkMagenta',
        'DarkCyan',
        'LightGray',
        'DarkGray',
        'White',
        'Black'
      ],
      htmlColors: [
        'red',
        'green',
        'yellow',
        'blue',
        'magenta',
        'cyan',
        'darkred',
        'darkgreen',
        'darkyellow',
        'darkblue',
        'darkmagenta',
        'darkcyan',
        'lightgray',
        'darkgray',
        'white',
        'black'
      ]
    }
  },
  methods: {
    bgi() {
      let i = this.colors.findIndex((e) => e == this.value);
      return this.bg(i >= 0 ? this.htmlColors[i] : this.htmlColors[0]);
    },
    bg(color) {
      return `background-color: ${color}`;
    },
    select(i) {
      this.$emit('input', this.colors[i]);
    }
  }
}
</script>

<style scoped>

.col-area-inner {
  width:12px;
  height:12px;
  margin: 4px;
  border-radius:5px;
  border: 2px solid #757575;
  display: inline-block;
  vertical-align: middle;
}

</style>